import React from "react";
import { ExternalLink } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const StatCard = ({ icon: Icon, label, value, accent = false, testid }) => (
  <div className={`card-surface ${accent ? "border-l-2 border-brand" : ""}`} data-testid={testid}>
    <Icon className="w-5 h-5 text-brand mb-3" strokeWidth={1.5} />
    <div className="label-mono">{label}</div>
    <div className="font-display text-3xl text-white mt-1">{value}</div>
  </div>
);

export const InfoSection = ({ title, children }) => (
  <div className="mt-5">
    <div className="label-mono mb-2">{title}</div>
    <div className="text-sm text-gray-300 leading-relaxed select-text">{children}</div>
  </div>
);

export const KV = ({ k, children }) => (
  <div className="flex flex-col">
    <div className="text-[10px] font-mono uppercase tracking-widest text-gray-500">{k}</div>
    <div className="text-sm text-gray-200 mt-0.5 select-text break-words">{children || <span className="text-gray-600">—</span>}</div>
  </div>
);

// External links only (user-provided URLs). Never used for protected API resources.
export const LinkChip = ({ href, label }) => {
  if (!href) return <span className="text-gray-600 text-sm">—</span>;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-brand hover:underline text-sm break-all inline-flex items-center gap-1.5" data-testid="external-link">
      <ExternalLink className="w-3.5 h-3.5 flex-shrink-0" /> {label || href}
    </a>
  );
};

// Authenticated download for protected /api/ resources — fetches the file as a
// blob using the Authorization header (never exposes the token in the URL).
export const AuthedDocLink = ({ href, label }) => {
  if (!href) return <span className="text-gray-600 text-sm">—</span>;
  const open = async () => {
    try {
      const resp = await api.get(href, { responseType: "blob" });
      const url = window.URL.createObjectURL(resp.data);
      window.open(url, "_blank", "noopener,noreferrer");
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch {
      toast.error("Unable to open document");
    }
  };
  return (
    <button type="button" onClick={open} className="text-brand hover:underline text-sm break-all inline-flex items-center gap-1.5" data-testid="authed-doc-link">
      <ExternalLink className="w-3.5 h-3.5 flex-shrink-0" /> {label || "Open document"}
    </button>
  );
};
